export default __webpack_public_path__ + "assets/images/e51ebab7ae634340262f06d0da5a9158.png";